import { render, staticRenderFns } from "./LiabilitiesOther.vue?vue&type=template&id=2d396b40"
import script from "./LiabilitiesOther.vue?vue&type=script&lang=js"
export * from "./LiabilitiesOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports